export const NAVBAR_HEIGHT = {
  DEFAULT: '--navbar-height-default',
} as const
export type NAVBAR_HEIGHT = (typeof NAVBAR_HEIGHT)[keyof typeof NAVBAR_HEIGHT]

export const PAGE_NOTIFICATION = {
  HEIGHT: '--page-notification-height',
} as const
export type PAGE_NOTIFICATION =
  (typeof PAGE_NOTIFICATION)[keyof typeof PAGE_NOTIFICATION]
